import { BOOLEAN } from '@js/constants/options';

export function destroyer(name) {
  return /_destroy\]?$/.test(name);
}

export function identify(sch, identifier, key) {
  return {
    group: sch[key].group,
    label: `Identificador de ${identifier}`,
    description: 'ID do objeto existente',
    validations: sch[key].validations || [],
    rules: {},
  };
}

export function destroy(sch, identifier, key) {
  return {
    group: sch[key].group,
    label: `Remover ${identifier}`,
    description: 'Remoção do objeto existente',
    validations: sch[key].validations || [],
    options: BOOLEAN,
    rules: sch._destroy?.rules || {},
    order: 99999,
  };
}
